 
// import React, { useState, useCallback, useEffect, useMemo } from "react";
// import { useSelector } from "react-redux";
// import {
//   Calendar,
//   Clock,
//   Truck,
//   ArrowRight,
//   AlertCircle,
//   User,
//   Weight,
//   ChevronRight,
//   CheckCircle,
//   ArrowLeft,
//   Package,
//   Plus,
//   Trash2,
//   MapPin,
//   Edit3,
//   FileText,
//   X
// } from "lucide-react";
// import { useScheduledBookings } from "../hooks/useScheduledBookings";
// import Select from "react-select";
// import { getAllWorkAreas } from "../services/workAreaService";
// import { PostBookingRequestDetails } from "../services/bookingService";
// import api from "../services/api";
// import bookingWS from "../services/bookingWebSocket";
// import { getAllVehicles } from "../services/vehicleService";
// import CustomTimePicker from "./CustomTimePicker";

// import CarIcon from "../assets/car.png";
// import VanIcon from "../assets/van.png";
// import BusIcon from "../assets/bus.png";
// import SuvIcon from "../assets/suv.png";
// import CabIcon from "../assets/cab.png";
// import ForkliftIcon from "../assets/fork lift.png";
// import LorryIcon from "../assets/lorry.png";
// import CherryIcon from "../assets/cherry.png";
// import TrailerIcon from "../assets/trailor.jpg";
// import CraneIcon from "../assets/crane.jpg";

// const RESOURCE_TYPES = ["Trailer", "Crane", "Trailer and Crane"];

// const getResourceTypeCode = (vehicleType) => {
//   const typeMap = {
//     Trailer: "T",
//     Crane: "C",
//     "Trailer and Crane": "TC",
//     "Cherry-Picker": "CH",
//     Forklift: "F",
//   };
//   return typeMap[vehicleType] || vehicleType;
// };

// const BookingScheduler = ({ vehicles, onBookingCreated }) => {
//   const { userDetails, authKey } = useSelector((state) => state.auth);
//   const { create, error, bookings } = useScheduledBookings();

//   const getLocalDateString = (date = new Date()) => {
//     const pad = (n) => String(n).padStart(2, "0");
//     const year = date.getFullYear();
//     const month = pad(date.getMonth() + 1);
//     const day = pad(date.getDate());
//     return `${year}-${month}-${day}`;
//   };

//   const getNowTimeString = () => {
//     const now = new Date();
//     now.setMinutes(now.getMinutes() + 2);
//     const pad = (n) => String(n).padStart(2, "0");
//     return `${pad(now.getHours())}:${pad(now.getMinutes())}`;
//   };

//   const [weightCategories, setWeightCategories] = useState([]);
//   const [selectedWeight, setSelectedWeight] = useState("");
//   const [filteredVehiclesByWeight, setFilteredVehiclesByWeight] = useState([]);
//   const [formStep, setFormStep] = useState(0);
//   const [selectedVehicle, setSelectedVehicle] = useState(null);

//   const [formData, setFormData] = useState({
//     bookedDate: getLocalDateString(),
//     vehicleId: "",
//     vehicleName: "",
//     vehicleType: "",
//     dSNo: "",
//     slatitude: "",
//     slongitude: "",
//     elatitude: "",
//     elongitude: "",
//     startTime: getNowTimeString(),
//     endTime: "",
//     workArea: "",
//     workAreaName: "",
//     workScope: "",
//     notes: "",
//     fromLocation: "",
//     fromLocationName: "",
//     toLocation: "",
//     toLocationName: "",
//     priority: "M",
//     remark: "",
//     needsResources: false,
//     tonnage: "",
//     weightCategory: "",
//   });

//   const [timeError, setTimeError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [workAreas, setWorkAreas] = useState([]);
//   const [isTimesValidated, setIsTimesValidated] = useState(false);
//   const [assignedResources, setAssignedResources] = useState([]);
//   const [selectedResourceType, setSelectedResourceType] = useState("");
//   const [loadingWorkAreas, setLoadingWorkAreas] = useState(false);
//   const [workAreaError, setWorkAreaError] = useState("");

//   const isValid24HourTime = (timeStr) => {
//     if (!timeStr) return false;
//     const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
//     return timeRegex.test(timeStr);
//   };

//   const timeToMinutes = (timeStr) => {
//     if (!timeStr || !isValid24HourTime(timeStr)) return null;
//     const [hours, minutes] = timeStr.split(":").map(Number);
//     return hours * 60 + minutes;
//   };

//   useEffect(() => {
//     const loadWeightCategories = async () => {
//       try {
//         const allVehicles = await getAllVehicles();
//         const forklifts = allVehicles.filter(
//           (vehicle) =>
//             vehicle.vehicleType === "Forklift" ||
//             vehicle.vehicleType?.toLowerCase() === "forklift"
//         );
//         const uniqueWeights = [...new Set(forklifts.filter(v => v.weightCat && v.weightCat.trim() !== "").map(v => v.weightCat))].sort();
//         setWeightCategories(uniqueWeights);
//       } catch (err) {
//         console.error("Failed to load weight categories:", err);
//       }
//     };
//     loadWeightCategories();
//   }, []);

//   useEffect(() => {
//     if (selectedWeight && vehicles) {
//       const filtered = vehicles.filter(
//         (vehicle) =>
//           (vehicle.vehicleType === "Forklift" || vehicle.vehicleType?.toLowerCase() === "forklift") &&
//           vehicle.weightCat === selectedWeight &&
//           vehicle.status === "Active"
//       );
//       setFilteredVehiclesByWeight(filtered);
//     } else {
//       setFilteredVehiclesByWeight([]);
//     }
//   }, [selectedWeight, vehicles]);

//   useEffect(() => {
//     const loadAreas = async () => {
//       try {
//         const data = await getAllWorkAreas();
//         setWorkAreas(data);
//       } catch (err) {
//         console.error("Failed to load work areas", err);
//       }
//     };
//     loadAreas();
//   }, []);

//   const weightOptions = useMemo(() => weightCategories.map((weight) => ({ value: weight, label: weight })), [weightCategories]);

//   const activeWorkAreas = useMemo(() => {
//     return (workAreas || []).filter((w) => {
//       const status = String(w?.status || w?.Status || w?.activeStatus || w?.isActive || "").trim().toLowerCase();
//       if (typeof w?.isActive === "boolean") return w.isActive;
//       return status === "active" || status === "a" || status === "1" || status === "true" || status === "yes";
//     });
//   }, [workAreas]);

//   const workAreaOptions = useMemo(() => activeWorkAreas.map((w) => ({ value: w.code || w.name, label: w.code ? `${w.code}` : w.name, code: w.code, name: w.name, raw: w.raw })), [activeWorkAreas]);
//   const workAreaOptions1 = useMemo(() => activeWorkAreas.map((w) => ({ value: w.code || w.name, label: w.code ? `${w.name}` : w.name, code: w.code, name: w.name, raw: w.raw })), [activeWorkAreas]);

//   const todayStr = getLocalDateString();
//   const getMinStartTime = useCallback(() => {
//     if (formData.bookedDate === todayStr) {
//       const now = new Date();
//       now.setMinutes(now.getMinutes() + 2);
//       const pad = (n) => String(n).padStart(2, "0");
//       return `${pad(now.getHours())}:${pad(now.getMinutes())}`;
//     }
//     return "00:00";
//   }, [formData.bookedDate, todayStr]);

//   const minStartTime = getMinStartTime();

//   const validateTimes = useCallback(() => {
//     if (!formData.startTime) { setTimeError("Start time is required"); setIsTimesValidated(false); return false; }
//     if (!formData.endTime) { setTimeError("End time is required"); setIsTimesValidated(false); return false; }
//     if (!isValid24HourTime(formData.startTime)) { setTimeError("Invalid start time format"); setIsTimesValidated(false); return false; }
//     if (!isValid24HourTime(formData.endTime)) { setTimeError("Invalid end time format"); setIsTimesValidated(false); return false; }
//     setTimeError("");
//     setIsTimesValidated(true);
//     return true;
//   }, [formData.startTime, formData.endTime]);

//   useEffect(() => {
//     if (formData.startTime && formData.endTime) validateTimes();
//     else if (formData.startTime && !formData.endTime) { setTimeError(""); setIsTimesValidated(false); }
//   }, [formData.startTime, formData.endTime, validateTimes]);

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
//   };

//   const handleStartTimeChange = (time) => {
//     setFormData((prev) => ({ ...prev, startTime: time }));
//     setIsTimesValidated(false);
//     if (formData.endTime && time) {
//       const startMinutes = timeToMinutes(time);
//       const endMinutes = timeToMinutes(formData.endTime);
//       if (endMinutes <= startMinutes) {
//         setFormData((prev) => ({ ...prev, endTime: "" }));
//         setTimeError("End time must be after start time");
//       } else { setTimeError(""); if (time && formData.endTime) validateTimes(); }
//     } else if (time && formData.endTime) validateTimes();
//   };

//   const handleEndTimeChange = (time) => {
//     setFormData((prev) => ({ ...prev, endTime: time }));
//     if (time && formData.startTime) {
//       setTimeError("");
//       setIsTimesValidated(true);
//     } else if (time && !formData.startTime) { setTimeError("Please set start time first"); setIsTimesValidated(false); }
//     else { setTimeError(""); setIsTimesValidated(false); }
//   };

//   const handleWeightSelect = (selectedOption) => {
//     const weight = selectedOption ? selectedOption.value : "";
//     setSelectedWeight(weight);
//     setFormData((prev) => ({ ...prev, weightCategory: weight, tonnage: weight }));
//     setSelectedVehicle(null);
//     setFormData((prev) => ({ ...prev, vehicleId: "", vehicleName: "", vehicleType: "", dSNo: "" }));
//     if (weight) setFormStep(1);
//   };

//   const handleVehicleSelection = (vehicle) => {
//     if (!isTimesValidated) {
//       setTimeError("⚠️ Please set valid start and end times before selecting a vehicle.");
//       return;
//     }
//     const hasDriver = !!(vehicle.dSNo || vehicle.driverSno);
//     if (!hasDriver) { alert("⚠️ No driver assigned to this vehicle. Please contact administration."); return; }
//     setSelectedVehicle(vehicle);
//     setFormData((prev) => ({
//       ...prev,
//       vehicleId: vehicle.vehicleId || vehicle.id || "",
//       vehicleName: vehicle.vehicleId || vehicle.id || "",
//       vehicleType: vehicle.vehicleType,
//       dSNo: vehicle.driverSno || vehicle.dSNo || "",
//       tonnage: vehicle.weightCat || prev.tonnage,
//     }));
//     setTimeout(() => setFormStep(3), 300);
//   };

//   const handleFromSelect = async (option) => {
//     const value = option ? option.value : "";
//     const label = option ? option.label : "";
//     const name = option?.name || label;
//     const raw = option?.raw || null;
//     setFormData((prev) => ({ ...prev, fromLocation: value, fromLocationName: name }));
//     if (value) {
//       const coords = await resolveCoordsForLocation(name || value, raw);
//       setFormData((prev) => ({ ...prev, slatitude: coords?.lat || "", slongitude: coords?.lng || "" }));
//     }
//   };

//   const handleToSelect = async (option) => {
//     const value = option ? option.value : "";
//     const label = option ? option.label : "";
//     const name = option?.name || label;
//     const raw = option?.raw || null;
//     setFormData((prev) => ({ ...prev, toLocation: value, toLocationName: name }));
//     if (value) {
//       const coords = await resolveCoordsForLocation(name || value, raw);
//       setFormData((prev) => ({ ...prev, elatitude: coords?.lat || "", elongitude: coords?.lng || "" }));
//     }
//   };

//   const resetFormData = () => {
//     setFormData({
//       bookedDate: getLocalDateString(),
//       vehicleId: "", vehicleName: "", vehicleType: "", dSNo: "",
//       slatitude: "", slongitude: "", elatitude: "", elongitude: "",
//       startTime: getNowTimeString(), endTime: "",
//       workArea: "", workAreaName: "", workScope: "", notes: "",
//       fromLocation: "", fromLocationName: "", toLocation: "", toLocationName: "",
//       priority: "M", remark: "", needsResources: false, tonnage: "", weightCategory: "",
//     });
//     setSelectedWeight("");
//     setSelectedVehicle(null);
//     setFormStep(0);
//     setIsTimesValidated(false);
//     setAssignedResources([]);
//     setSelectedResourceType("");
//   };

//   const mapPriority = (value) => {
//     if (!value) return "";
//     const raw = value.toString().trim();
//     const upper = raw.toUpperCase();
//     if (["H", "HE", "M", "ML", "L"].includes(upper)) return upper;
//     const parenMatch = raw.match(/\(([^)]+)\)/);
//     if (parenMatch?.[1]) {
//       const code = parenMatch[1].trim().toUpperCase();
//       if (["H", "HE", "M", "ML", "L"].includes(code)) return code;
//     }
//     const lower = raw.toLowerCase();
//     if (lower.includes("high") && lower.includes("moderate")) return "HE";
//     if (lower.includes("moderate") && lower.includes("low")) return "ML";
//     if (lower.includes("high")) return "H";
//     if (lower.includes("moderate")) return "M";
//     if (lower.includes("low")) return "L";
//     return upper.charAt(0);
//   };

//   const sendBookingAlert = (payload) => {
//     if (bookingWS.isReady()) { bookingWS.sendBooking(payload); return; }
//     if (authKey) bookingWS.connectAsEmployee(authKey);
//     setTimeout(() => { if (bookingWS.isReady()) bookingWS.sendBooking(payload); }, 1500);
//   };

//   const scheduleBookingAlert = (savedBooking, fallbackBooking) => {
//     if (!formData.bookedDate || !formData.startTime) return;
//     const scheduledStart = new Date(`${formData.bookedDate}T${formData.startTime}:00`);
//     if (isNaN(scheduledStart.getTime())) return;
//     const bookingForAlert = {
//       bId: savedBooking?.bId || savedBooking?.BId || fallbackBooking?.bId || "",
//       vId: savedBooking?.vId || fallbackBooking?.vId || formData.vehicleId,
//       dSNo: savedBooking?.dSNo || fallbackBooking?.dSNo || formData.dSNo,
//       employeeName: userDetails?.Name || "Employee",
//       slatitude: savedBooking?.slatitude || fallbackBooking?.slatitude || "",
//       slongitude: savedBooking?.slongitude || fallbackBooking?.slongitude || "",
//       elatitude: savedBooking?.elatitude || fallbackBooking?.elatitude || "",
//       elongitude: savedBooking?.elongitude || fallbackBooking?.elongitude || "",
//       totalDestence: savedBooking?.totalDestence || fallbackBooking?.totalDestence || "0",
//       bookingDT: savedBooking?.bookingDT || fallbackBooking?.bookingDT || formatLocalDateTime(new Date()),
//       status: savedBooking?.status || fallbackBooking?.status || "P",
//       bookingSno: savedBooking?.bookingSno || fallbackBooking?.bookingSno || userDetails?.ServiceNo || "",
//       dlatitude: savedBooking?.dlatitude || fallbackBooking?.dlatitude || "",
//       dlongitude: savedBooking?.dlongitude || fallbackBooking?.dlongitude || "",
//       bsTime: savedBooking?.bsTime || `${formData.bookedDate} ${formData.startTime}:00`,
//       beTime: savedBooking?.beTime || `${formData.bookedDate} ${formData.endTime}:00`,
//       From: savedBooking?.From || formData.fromLocationName || formData.fromLocation || "",
//       TO: savedBooking?.TO || formData.toLocationName || formData.toLocation || "",
//       WorkArea: savedBooking?.WorkArea || formData.workAreaName || formData.workArea || "",
//       WorkScope: savedBooking?.WorkScope || formData.workScope || "",
//       Priority: savedBooking?.Priority || formData.priority || "",
//       Remark: savedBooking?.Remark || formData.remark || "",
//       BookingStatus: "S",
//     };
//     const delayMs = scheduledStart.getTime() - Date.now();
//     if (delayMs <= 0) { sendBookingAlert(bookingForAlert); return; }
//     setTimeout(() => sendBookingAlert(bookingForAlert), delayMs);
//   };

//   const parseLocalDateTime = (value) => {
//     if (!value) return null;
//     if (value instanceof Date) return value;
//     const raw = String(value).trim();
//     if (!raw) return null;
//     if (raw.includes("T")) { const d = new Date(raw); return isNaN(d.getTime()) ? null : d; }
//     const parts = raw.split(" ");
//     if (parts.length >= 2) { const d = new Date(`${parts[0]}T${parts[1]}`); return isNaN(d.getTime()) ? null : d; }
//     const d = new Date(raw);
//     return isNaN(d.getTime()) ? null : d;
//   };

//   const scheduleSubBookingAlerts = (subBookings, mainBooking, savedBooking) => {
//     if (!Array.isArray(subBookings) || subBookings.length === 0) return;
//     subBookings.forEach((sub) => {
//       const startTime = parseLocalDateTime(sub.subbsTime);
//       if (!startTime) return;
//       const bookingForAlert = {
//         bId: savedBooking?.bId || savedBooking?.BId || mainBooking?.bId || "",
//         vId: sub.subvid || sub.vId || "",
//         dSNo: sub.subdSNo || "",
//         employeeName: userDetails?.Name || "Employee",
//         slatitude: sub.subslatitude || mainBooking?.slatitude || "",
//         slongitude: sub.subslongitude || mainBooking?.slongitude || "",
//         elatitude: sub.subelatitude || mainBooking?.elatitude || "",
//         elongitude: sub.subelongitude || mainBooking?.elongitude || "",
//         totalDestence: sub.subtotalDestence || mainBooking?.totalDestence || "0",
//         bookingDT: sub.subbookingDT || mainBooking?.bookingDT || formatLocalDateTime(new Date()),
//         status: sub.substatus || mainBooking?.status || "P",
//         bookingSno: sub.subbookingSno || mainBooking?.bookingSno || userDetails?.ServiceNo || "",
//         dlatitude: sub.subdlatitude || mainBooking?.dlatitude || "",
//         dlongitude: sub.subdlongitude || mainBooking?.dlongitude || "",
//         bsTime: sub.subbsTime || "",
//         beTime: sub.subbeTime || "",
//         From: sub.subFrom || mainBooking?.From || formData.fromLocationName || formData.fromLocation || "",
//         TO: sub.subTO || mainBooking?.TO || formData.toLocationName || formData.toLocation || "",
//         WorkArea: mainBooking?.WorkArea || formData.workAreaName || formData.workArea || "",
//         WorkScope: mainBooking?.WorkScope || formData.workScope || "",
//         Priority: mainBooking?.Priority || formData.priority || "",
//         Remark: sub.subRemark || mainBooking?.Remark || formData.remark || "",
//         BookingStatus: "S",
//       };
//       const delayMs = startTime.getTime() - Date.now();
//       if (delayMs <= 0) { sendBookingAlert(bookingForAlert); return; }
//       setTimeout(() => sendBookingAlert(bookingForAlert), delayMs);
//     });
//   };

//   const createSubBookingsFromResources = () => {
//     return assignedResources.map((resource, index) => {
//       const vehicleCode = getResourceTypeCode(resource.type);
//       return {
//         subvid: "",
//         subdSNo: "",
//         subbsTime: `${formData.bookedDate} ${formData.startTime}:00`,
//         subbeTime: `${formData.bookedDate} ${formData.endTime}:00`,
//         subFrom: formData.fromLocation,
//         subTO: formData.toLocation,
//         subRemark: `Resource Type: ${resource.type} - ${resource.remark || ""}`,
//         subslatitude: formData.slatitude,
//         subslongitude: formData.slongitude,
//         subelatitude: formData.elatitude,
//         subelongitude: formData.elongitude,
//         subtotalDestence: "0",
//         substatus: "P",
//         subbookingDT: formatLocalDateTime(new Date()),
//         subbookingSno: userDetails?.ServiceNo || "",
//         subdlatitude: formData.slatitude,
//         subdlongitude: formData.slongitude,
//         subVehicleCode: vehicleCode,
//         resourceType: resource.type,
//         resourceId: resource.id,
//         resourceName: resource.type,
//         startTime: resource.startTime,
//         endTime: resource.endTime,
//       };
//     });
//   };

//   const handleResourceSubmit = async () => {
//     setLoading(true);
//     try {
//       const now = new Date();
//       const subBookings = createSubBookingsFromResources();
//       let subBookValue = "";
//       if (subBookings.length > 0) {
//         const resourceCodes = subBookings.map(sb => sb.subVehicleCode).filter(Boolean);
//         subBookValue = resourceCodes.join(",");
//       }

//       const mainBooking = {
//         bId: "",
//         vId: formData.vehicleId || "",
//         dSNo: formData.dSNo || "",
//         slatitude: formData.slatitude,
//         slongitude: formData.slongitude,
//         elatitude: formData.elatitude,
//         elongitude: formData.elongitude,
//         status: "P",
//         bookingDT: formatLocalDateTime(now),
//         bsTime: `${formData.bookedDate} ${formData.startTime}:00`,
//         beTime: `${formData.bookedDate} ${formData.endTime}:00`,
//         totalDestence: "0",
//         dlongitude: formData.slongitude,
//         bookingSno: userDetails?.ServiceNo || "",
//         dlatitude: formData.slatitude,
//         WorkArea: formData.workArea,
//         WorkScope: formData.workScope,
//         Priority: mapPriority(formData.priority),
//         From: formData.fromLocation,
//         TO: formData.toLocation,
//         Remark: formData.remark,
//         SubBook: subBookValue,
//         BookingStatus: "S",
//         tonnage: formData.tonnage,
//       };

//       const finalPayload = [mainBooking];
//       const apiResponse = await PostBookingRequestDetails(finalPayload);
//       const responseData = apiResponse?.data;
//       const savedBooking = (Array.isArray(responseData?.resultSet) && responseData.resultSet[0]) || responseData?.result || (Array.isArray(responseData) && responseData[0]) || null;

//       if (responseData?.statusCode && responseData.statusCode !== 200) {
//         throw new Error(responseData.result || `Backend error: ${responseData.statusCode}`);
//       }

//       scheduleBookingAlert(savedBooking, mainBooking);
//       scheduleSubBookingAlerts(subBookings, mainBooking, savedBooking);

//       const newBooking = await create({ ...formData, bId: savedBooking?.bId || savedBooking?.BId || formData.bId, BookingStatus: "S", assignedResources });
//       resetFormData();
//       setTimeError("");
//       if (onBookingCreated) onBookingCreated(newBooking);
//     } catch (err) {
//       console.error("Booking with resources failed:", err);
//       setTimeError(err.message || "Failed to create booking with resources");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateTimes() || timeError) return;
//     if (!formData.bookedDate) { setTimeError("Booking date is required"); return; }
//     if (!formData.startTime || !formData.endTime) { setTimeError("Start and end times are required"); return; }
//     if (!formData.fromLocation || !formData.toLocation) { setTimeError("Both from and to locations are required"); return; }

//     const now = new Date();
//     const bookingDT = formatLocalDateTime(now);
//     const bsTime = `${formData.bookedDate} ${formData.startTime}:00`;
//     const beTime = `${formData.bookedDate} ${formData.endTime}:00`;

//     let fromCoords = { lat: formData.slatitude, lng: formData.slongitude };
//     let toCoords = { lat: formData.elatitude, lng: formData.elongitude };

//     if (!fromCoords.lat || !fromCoords.lng || !toCoords.lat || !toCoords.lng) {
//       const [geoFrom, geoTo] = await Promise.all([
//         geocodeToLatLng(formData.fromLocationName || formData.workAreaName || formData.fromLocation || formData.workArea),
//         geocodeToLatLng(formData.toLocationName || formData.workAreaName || formData.toLocation || formData.workArea),
//       ]);
//       fromCoords = { lat: fromCoords.lat || geoFrom.lat, lng: fromCoords.lng || geoFrom.lng };
//       toCoords = { lat: toCoords.lat || geoTo.lat, lng: toCoords.lng || geoTo.lng };
//     }

//     if (!fromCoords.lat || !fromCoords.lng || !toCoords.lat || !toCoords.lng) {
//       if (!process.env.REACT_APP_ORS_KEY) setTimeError("Pickup/Drop coordinates missing. Add lat/long to Work Areas or set REACT_APP_ORS_KEY.");
//       else setTimeError("Pickup/Drop coordinates are missing. Please select locations with valid coordinates.");
//       return;
//     }

//     setFormData((prev) => ({ ...prev, slatitude: fromCoords.lat, slongitude: fromCoords.lng, elatitude: toCoords.lat, elongitude: toCoords.lng }));

//     if (formData.needsResources && assignedResources.length > 0) {
//       await handleResourceSubmit();
//     } else {
//       const mainBooking = {
//         bId: "", vId: formData.vehicleId || "", dSNo: formData.dSNo || "",
//         slatitude: fromCoords.lat, slongitude: fromCoords.lng,
//         elatitude: toCoords.lat, elongitude: toCoords.lng,
//         status: "P", bookingDT, bsTime, beTime, totalDestence: "0",
//         dlongitude: fromCoords.lng, bookingSno: userDetails?.ServiceNo || "",
//         dlatitude: fromCoords.lat, WorkArea: formData.workArea, WorkScope: formData.workScope,
//         Priority: mapPriority(formData.priority), From: formData.fromLocation, TO: formData.toLocation,
//         Remark: formData.remark, SubBook: "", SubBookings: [], BookingStatus: "S", tonnage: formData.tonnage,
//       };

//       const payload = [mainBooking];
//       setLoading(true);
//       try {
//         const apiResponse = await PostBookingRequestDetails(payload);
//         const responseData = apiResponse?.data;
//         const savedBooking = (Array.isArray(responseData?.resultSet) && responseData.resultSet[0]) || responseData?.result || (Array.isArray(responseData) && responseData[0]) || null;
//         scheduleBookingAlert(savedBooking, mainBooking);
//         const newBooking = await create({ ...formData, bId: savedBooking?.bId || savedBooking?.BId || formData.bId, BookingStatus: "S" });
//         resetFormData();
//         setTimeError("");
//         if (onBookingCreated) onBookingCreated(newBooking);
//       } catch (err) {
//         console.error("Booking creation failed:", err);
//         setTimeError(err?.message || "Submission failed. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   const selectPortalStyles = { menuPortal: (base) => ({ ...base, zIndex: 9999 }), menu: (base) => ({ ...base, zIndex: 9999 }) };

//   const StepIndicator = () => (
//     <div className="flex items-center justify-between mb-6">
//       {[{ step: 0, label: "Weight" }, { step: 1, label: "Dates" }, { step: 2, label: "Details" }].map((item, idx) => (
//         <div key={item.step} className="flex items-center flex-1">
//           <div className="flex flex-col items-center">
//             <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center font-bold text-xs sm:text-sm transition-all ${formStep > item.step ? "bg-emerald-500 text-white" : formStep === item.step ? "bg-gray-900 text-white ring-4 ring-gray-300" : "bg-gray-200 text-gray-500"}`}>
//               {formStep > item.step ? <CheckCircle size={16} /> : item.step + 1}
//             </div>
//             <span className="text-[10px] sm:text-xs mt-1 font-medium text-gray-600">{item.label}</span>
//           </div>
//           {idx < 2 && <div className={`flex-1 h-0.5 mx-2 rounded transition-all ${formStep > item.step ? "bg-emerald-500" : "bg-gray-200"}`} />}
//         </div>
//       ))}
//     </div>
//   );

//   const formatLocalDateTime = (date = new Date()) => {
//     const pad = (n) => String(n).padStart(2, "0");
//     return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
//   };

//   const geocodeToLatLng = async (query) => {
//     const apiKey = process.env.REACT_APP_ORS_KEY;
//     if (!apiKey || !query) return { lat: "", lng: "" };
//     try {
//       const base = String(query).trim();
//       const variants = [base, `${base} Sri Lanka`, `${base}, Sri Lanka`, `${base} LK`].filter(Boolean);
//       for (const q of variants) {
//         const url = `https://api.openrouteservice.org/geocode/search?api_key=${apiKey}&text=${encodeURIComponent(q)}&boundary.country=LK&size=1`;
//         const res = await fetch(url);
//         const data = await res.json();
//         const feature = data.features?.[0];
//         if (!feature) continue;
//         const [lng, lat] = feature.geometry.coordinates || [];
//         if (typeof lat !== "number" || typeof lng !== "number") continue;
//         return { lat: lat.toFixed(6), lng: lng.toFixed(6) };
//       }
//       return { lat: "", lng: "" };
//     } catch (err) { return { lat: "", lng: "" }; }
//   };

//   const extractCoords = (raw) => {
//     if (!raw) return null;
//     const pickFirstNumber = (obj, keys) => {
//       for (const k of keys) {
//         if (obj[k] !== undefined && obj[k] !== null && obj[k] !== "") {
//           const n = parseFloat(obj[k]);
//           if (!Number.isNaN(n)) return n;
//         }
//       }
//       return null;
//     };
//     const latKeys = ["latitude", "Latitude", "lat", "LAT", "Lat", "LatitudeValue", "WALatitude", "WA_Latitude", "WA_latitude", "WaLatitude", "WALat", "WorkAreaLatitude"];
//     const lngKeys = ["longitude", "Longitude", "lng", "LNG", "Long", "LongitudeValue", "WALongitude", "WA_Longitude", "WA_longitude", "WaLongitude", "WALong", "WorkAreaLongitude"];
//     let latNum = pickFirstNumber(raw, latKeys);
//     let lngNum = pickFirstNumber(raw, lngKeys);
//     if (latNum === null || lngNum === null) {
//       const keys = Object.keys(raw || {});
//       const latKey = keys.find((k) => k.toLowerCase().includes("lat"));
//       const lngKey = keys.find((k) => k.toLowerCase().includes("lon") || k.toLowerCase().includes("lng") || k.toLowerCase().includes("long"));
//       if (latNum === null && latKey) { const n = parseFloat(raw[latKey]); if (!Number.isNaN(n)) latNum = n; }
//       if (lngNum === null && lngKey) { const n = parseFloat(raw[lngKey]); if (!Number.isNaN(n)) lngNum = n; }
//     }
//     if (latNum === null || lngNum === null) return null;
//     return { lat: latNum.toFixed(6), lng: lngNum.toFixed(6) };
//   };

//   const resolveCoordsForLocation = async (name, raw) => {
//     const fromRaw = extractCoords(raw);
//     if (fromRaw) return fromRaw;
//     return geocodeToLatLng(name);
//   };

//   const handleAddResource = (type) => {
//     if (assignedResources.length > 0) {
//       alert("You can only add ONE resource type per booking. Please remove the existing resource first if you want to change it.");
//       return;
//     }
//     const vehicleCode = getResourceTypeCode(type);
//     const newAssignment = {
//       id: `${Date.now()}`,
//       type: type,
//       vehicleCode: vehicleCode,
//       startTime: formData.startTime,
//       endTime: formData.endTime,
//       from: formData.fromLocation,
//       fromName: formData.fromLocationName,
//       to: formData.toLocation,
//       toName: formData.toLocationName,
//       remark: formData.remark,
//     };
//     setAssignedResources((prev) => [...prev, newAssignment]);
//     setSelectedResourceType("");
//   };

//   const handleRemoveResource = (id) => {
//     setAssignedResources(assignedResources.filter((r) => r.id !== id));
//   };

//   const fetchWorkAreasForResources = async () => {
//     setLoadingWorkAreas(true);
//     setWorkAreaError("");
//     try { const data = await getAllWorkAreas(); setWorkAreas(data); } 
//     catch (err) { setWorkAreaError("Unable to load work areas"); } 
//     finally { setLoadingWorkAreas(false); }
//   };

//   const getPriorityMeta = (priority) => {
//     if (!priority) return { label: "", className: "bg-gray-500" };
//     const normalized = priority.toString().trim().toUpperCase();
//     if (normalized === "H") return { label: "High", className: "bg-red-500" };
//     if (normalized === "HE") return { label: "High to Moderate", className: "bg-orange-500" };
//     if (normalized === "M") return { label: "Moderate", className: "bg-yellow-500" };
//     if (normalized === "ML") return { label: "Moderate to Low", className: "bg-lime-500" };
//     if (normalized === "L") return { label: "Low", className: "bg-green-500" };
//     return { label: priority.toString(), className: "bg-gray-500" };
//   };

//   return (
//     <div className="w-full min-h-screen bg-gray-50 py-4 sm:py-6 md:py-8">
//       <div className="max-w-2xl mx-auto px-3 sm:px-4">
//         {/* Header */}
//         <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-4 sm:p-6 mb-6">
//           <div className="flex items-center gap-3 mb-2">
//             <div className="p-2 bg-gray-900 rounded-lg">
//               <Truck size={20} className="text-white" />
//             </div>
//             <h1 className="text-lg sm:text-xl font-semibold text-gray-900">Booking Wizard</h1>
//           </div>
//           <p className="text-xs sm:text-sm text-gray-500">Complete this form step-by-step to schedule your vehicle</p>
//         </div>

//         <StepIndicator />

//         <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
//           <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-4">
//             {/* User Info */}
//             {userDetails && (
//               <div className="bg-gray-50 border border-gray-100 rounded-lg p-3 flex items-center gap-3">
//                 <div className="p-2 bg-gray-900 rounded-lg">
//                   <User size={16} className="text-white" />
//                 </div>
//                 <div>
//                   <p className="text-sm font-medium text-gray-900">{userDetails.Name || "Employee" || "Engineer" || "Supervisor"}</p>
//                   <p className="text-xs text-gray-500">Service No: {userDetails.ServiceNo}</p>
//                 </div>
//               </div>
//             )}

//             {(error || timeError) && (
//               <div className="bg-red-50 border border-red-200 rounded-lg p-3 flex gap-2">
//                 <AlertCircle size={16} className="text-red-600 flex-shrink-0 mt-0.5" />
//                 <p className="text-xs text-red-700">{error || timeError}</p>
//               </div>
//             )}

//             {/* Assigned Resource */}
//             {assignedResources.length > 0 && (
//               <div className="bg-indigo-50 border border-indigo-100 rounded-lg p-3">
//                 <h4 className="text-xs font-semibold text-indigo-800 mb-2 flex items-center gap-1">Selected Resource</h4>
//                 {assignedResources.map((resource) => (
//                   <div key={resource.id} className="bg-white rounded-lg p-2 flex justify-between items-center">
//                     <div><p className="text-sm font-medium text-gray-800">{resource.type}</p><p className="text-xs text-gray-500">Code: {resource.vehicleCode}</p></div>
//                     <button type="button" onClick={() => handleRemoveResource(resource.id)} className="text-red-500 hover:text-red-700"><Trash2 size={14} /></button>
//                   </div>
//                 ))}
//               </div>
//             )}

//             {/* STEP 0: Weight Selection */}
//             {formStep === 0 && (
//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-xs font-medium text-gray-700 mb-2">Forklift Weight Category <span className="text-red-500">*</span></label>
//                   <Select options={weightOptions} value={weightOptions.find(opt => opt.value === selectedWeight) || null} onChange={handleWeightSelect} placeholder="Choose a weight category..." isClearable className="react-select-container text-sm" classNamePrefix="react-select" menuPortalTarget={document.body} styles={selectPortalStyles} />
//                   {weightCategories.length > 0 && (
//                     <div className="mt-3 p-2 bg-gray-50 border border-gray-100 rounded-lg">
//                       <p className="text-xs text-gray-600">Available capacities: {weightCategories.join(", ")}</p>
//                     </div>
//                   )}
//                 </div>
//                 <button type="button" onClick={() => selectedWeight && setFormStep(1)} disabled={!selectedWeight} className="w-full bg-gray-900 hover:bg-gray-800 disabled:bg-gray-300 text-white font-medium py-2 rounded-lg transition text-sm flex items-center justify-center gap-2">Next: Booking Dates <ChevronRight size={14} /></button>
//               </div>
//             )}

//             {/* STEP 1: Date & Location */}
//             {formStep === 1 && (
//               <div className="space-y-4">
//                 <div className="bg-emerald-50 border border-emerald-100 rounded-lg p-2"><p className="text-xs font-medium text-emerald-800">Weight Selected: {selectedWeight}</p></div>
//                 <div><label className="block text-xs font-medium text-gray-700 mb-2">Booking Date <span className="text-red-500">*</span></label><input type="date" name="bookedDate" value={formData.bookedDate} onChange={handleInputChange} min={getLocalDateString()} className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:border-gray-400" /></div>
//                 <div className="grid grid-cols-2 gap-3"><CustomTimePicker label="Start Time" value={formData.startTime} onChange={handleStartTimeChange} required min={minStartTime} error={timeError && timeError.includes("Start") ? timeError : null} /><CustomTimePicker label="End Time" value={formData.endTime} onChange={handleEndTimeChange} required error={timeError && timeError.includes("End") ? timeError : null} /></div>
//                 <div className="grid grid-cols-2 gap-3"><div><label className="block text-xs font-medium text-gray-700 mb-2">From <span className="text-red-500">*</span></label><Select options={workAreaOptions1} value={workAreaOptions1.find(o => o.value === formData.fromLocation) || null} onChange={handleFromSelect} placeholder="From location..." isClearable className="react-select-container text-sm" classNamePrefix="react-select" menuPortalTarget={document.body} styles={selectPortalStyles} /></div><div><label className="block text-xs font-medium text-gray-700 mb-2">To <span className="text-red-500">*</span></label><Select options={workAreaOptions1} value={workAreaOptions1.find(o => o.value === formData.toLocation) || null} onChange={handleToSelect} placeholder="To location..." isClearable className="react-select-container text-sm" classNamePrefix="react-select" menuPortalTarget={document.body} styles={selectPortalStyles} /></div></div>
//                 <div className="flex gap-3"><button type="button" onClick={() => setFormStep(0)} className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium py-2 rounded-lg text-sm flex items-center justify-center gap-2"><ArrowLeft size={14} /> Back</button><button type="button" onClick={() => { if (validateTimes()) setFormStep(3); }} disabled={!formData.bookedDate || !formData.startTime || !formData.endTime || !formData.fromLocation || !formData.toLocation || timeError !== ""} className="flex-1 bg-gray-900 hover:bg-gray-800 disabled:bg-gray-300 text-white font-medium py-2 rounded-lg text-sm flex items-center justify-center gap-2">Next <ChevronRight size={14} /></button></div>
//               </div>
//             )}

//             {/* STEP 3: Details & Resources */}
//             {formStep === 3 && (
//               <div className="space-y-4">
//                 <div><label className="block text-xs font-medium text-gray-700 mb-2">Remarks (Optional)</label><textarea name="remark" value={formData.remark} onChange={handleInputChange} placeholder="Add any additional remarks..." className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:border-gray-400 resize-none" rows="2" /></div>
                
//                 <div className="bg-gray-50 border border-gray-100 rounded-lg p-3">
//                   <label className="flex items-start gap-2 cursor-pointer">
//                     <input type="checkbox" name="needsResources" checked={formData.needsResources} onChange={(e) => { handleInputChange(e); if (e.target.checked) fetchWorkAreasForResources(); else { setAssignedResources([]); setSelectedResourceType(""); } }} className="w-4 h-4 mt-0.5 rounded border-gray-300" />
//                     <div><span className="text-sm font-medium text-gray-700">Need additional resources?</span><p className="text-xs text-gray-500">(Trailer, Crane - Only ONE resource can be selected)</p></div>
//                   </label>
//                 </div>

//                 {formData.needsResources && (
//                   <div className="border border-dashed border-indigo-200 rounded-lg p-4 bg-indigo-50/30 space-y-3">
//                     <h3 className="text-sm font-semibold text-gray-800 flex items-center gap-1">Add Resource</h3>
//                     <div className="flex flex-wrap gap-2">
//                       {RESOURCE_TYPES.map((type) => {
//                         const hasResource = assignedResources.length > 0;
//                         const isSelected = assignedResources.some(resource => resource.type === type);
//                         return (
//                           <button key={type} type="button" onClick={() => handleAddResource(type)} disabled={hasResource && !isSelected} className={`px-3 py-1.5 rounded-lg text-xs font-medium transition ${hasResource && !isSelected ? "bg-gray-300 cursor-not-allowed opacity-50" : isSelected ? "bg-emerald-600 text-white" : "bg-gray-900 text-white hover:bg-gray-800"}`}>
//                             {isSelected ? <><CheckCircle size={12} className="inline mr-1" /> {type}</> : <><Plus size={12} className="inline mr-1" /> {type}</>}
//                           </button>
//                         );
//                       })}
//                     </div>
//                     {assignedResources.length === 0 && <p className="text-xs text-amber-600">⚠️ Choose one resource type</p>}
//                     {assignedResources.length === 1 && <p className="text-xs text-emerald-600">✓ Resource selected</p>}
//                     {workAreaError && <p className="text-xs text-red-600">{workAreaError}</p>}
//                   </div>
//                 )}

//                 <div className="flex gap-3">
//                   <button type="button" onClick={() => setFormStep(1)} className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium py-2 rounded-lg text-sm flex items-center justify-center gap-2"><ArrowLeft size={14} /> Back</button>
//                   <button type="submit" disabled={loading || timeError !== "" || (formData.needsResources && assignedResources.length === 0)} className="flex-1 bg-gray-900 hover:bg-gray-800 disabled:bg-gray-300 text-white font-medium py-2 rounded-lg text-sm flex items-center justify-center gap-2">
//                     {loading ? <><div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div> Creating...</> : <><CheckCircle size={14} /> Confirm Booking</>}
//                   </button>
//                 </div>
//               </div>
//             )}
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BookingScheduler;





// src/components/BookingScheduler.jsx
import React, { useState, useCallback, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import {
  Calendar,
  Clock,
  Truck,
  ArrowRight,
  AlertCircle,
  User,
  Weight,
  ChevronRight,
  CheckCircle,
  ArrowLeft,
  Package,
  Plus,
  Trash2,
  MapPin,
  Edit3,
  FileText,
  X
} from "lucide-react";
import { useScheduledBookings } from "../hooks/useScheduledBookings";
import Select from "react-select";
import { getAllWorkAreas } from "../services/workAreaService";
import { PostBookingRequestDetails } from "../services/bookingService";
import api from "../services/api";
import bookingWS from "../services/bookingWebSocket";
import { getAllVehicles } from "../services/vehicleService";
import CustomTimePicker from "./CustomTimePicker";

import CarIcon from "../assets/car.png";
import VanIcon from "../assets/van.png";
import BusIcon from "../assets/bus.png";
import SuvIcon from "../assets/suv.png";
import CabIcon from "../assets/cab.png";
import ForkliftIcon from "../assets/fork lift.png";
import LorryIcon from "../assets/lorry.png";
import CherryIcon from "../assets/cherry.png";
import TrailerIcon from "../assets/trailor.jpg";
import CraneIcon from "../assets/crane.jpg";

const RESOURCE_TYPES = ["Trailer", "Crane", "Trailer and Crane"];

const getResourceTypeCode = (vehicleType) => {
  const typeMap = {
    Trailer: "T",
    Crane: "C",
    "Trailer and Crane": "TC",
    "Cherry-Picker": "CH",
    Forklift: "F",
  };
  return typeMap[vehicleType] || vehicleType;
};

const BookingScheduler = ({ vehicles, onBookingCreated }) => {
  const { userDetails, authKey } = useSelector((state) => state.auth);
  const { create, error, bookings } = useScheduledBookings();

  const getLocalDateString = (date = new Date()) => {
    const pad = (n) => String(n).padStart(2, "0");
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    return `${year}-${month}-${day}`;
  };

  const getNowTimeString = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 2);
    const pad = (n) => String(n).padStart(2, "0");
    return `${pad(now.getHours())}:${pad(now.getMinutes())}`;
  };

  const [weightCategories, setWeightCategories] = useState([]);
  const [selectedWeight, setSelectedWeight] = useState("");
  const [filteredVehiclesByWeight, setFilteredVehiclesByWeight] = useState([]);
  const [formStep, setFormStep] = useState(0);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const [formData, setFormData] = useState({
    bookedDate: getLocalDateString(),
    vehicleId: "",
    vehicleName: "",
    vehicleType: "",
    dSNo: "",
    slatitude: "",
    slongitude: "",
    elatitude: "",
    elongitude: "",
    startTime: getNowTimeString(),
    endTime: "",
    workArea: "",
    workAreaName: "",
    workScope: "",
    notes: "",
    fromLocation: "",
    fromLocationName: "",
    toLocation: "",
    toLocationName: "",
    priority: "M",
    remark: "",
    needsResources: false,
    tonnage: "",
    weightCategory: "",
  });

  const [timeError, setTimeError] = useState("");
  const [loading, setLoading] = useState(false);
  const [workAreas, setWorkAreas] = useState([]);
  const [isTimesValidated, setIsTimesValidated] = useState(false);
  const [assignedResources, setAssignedResources] = useState([]);
  const [selectedResourceType, setSelectedResourceType] = useState("");
  const [loadingWorkAreas, setLoadingWorkAreas] = useState(false);
  const [workAreaError, setWorkAreaError] = useState("");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isValid24HourTime = (timeStr) => {
    if (!timeStr) return false;
    const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
    return timeRegex.test(timeStr);
  };

  const timeToMinutes = (timeStr) => {
    if (!timeStr || !isValid24HourTime(timeStr)) return null;
    const [hours, minutes] = timeStr.split(":").map(Number);
    return hours * 60 + minutes;
  };

  useEffect(() => {
    const loadWeightCategories = async () => {
      try {
        const allVehicles = await getAllVehicles();
        const forklifts = allVehicles.filter(
          (vehicle) =>
            vehicle.vehicleType === "Forklift" ||
            vehicle.vehicleType?.toLowerCase() === "forklift"
        );
        const uniqueWeights = [...new Set(forklifts.filter(v => v.weightCat && v.weightCat.trim() !== "").map(v => v.weightCat))].sort();
        setWeightCategories(uniqueWeights);
      } catch (err) {
        console.error("Failed to load weight categories:", err);
      }
    };
    loadWeightCategories();
  }, []);

  useEffect(() => {
    if (selectedWeight && vehicles) {
      const filtered = vehicles.filter(
        (vehicle) =>
          (vehicle.vehicleType === "Forklift" || vehicle.vehicleType?.toLowerCase() === "forklift") &&
          vehicle.weightCat === selectedWeight &&
          vehicle.status === "Active"
      );
      setFilteredVehiclesByWeight(filtered);
    } else {
      setFilteredVehiclesByWeight([]);
    }
  }, [selectedWeight, vehicles]);

  useEffect(() => {
    const loadAreas = async () => {
      try {
        const data = await getAllWorkAreas();
        setWorkAreas(data);
      } catch (err) {
        console.error("Failed to load work areas", err);
      }
    };
    loadAreas();
  }, []);

  const weightOptions = useMemo(() => weightCategories.map((weight) => ({ value: weight, label: weight })), [weightCategories]);

  const activeWorkAreas = useMemo(() => {
    return (workAreas || []).filter((w) => {
      const status = String(w?.status || w?.Status || w?.activeStatus || w?.isActive || "").trim().toLowerCase();
      if (typeof w?.isActive === "boolean") return w.isActive;
      return status === "active" || status === "a" || status === "1" || status === "true" || status === "yes";
    });
  }, [workAreas]);

  const workAreaOptions = useMemo(() => activeWorkAreas.map((w) => ({ value: w.code || w.name, label: w.code ? `${w.code}` : w.name, code: w.code, name: w.name, raw: w.raw })), [activeWorkAreas]);
  const workAreaOptions1 = useMemo(() => activeWorkAreas.map((w) => ({ value: w.code || w.name, label: w.code ? `${w.name}` : w.name, code: w.code, name: w.name, raw: w.raw })), [activeWorkAreas]);

  const todayStr = getLocalDateString();
  const getMinStartTime = useCallback(() => {
    if (formData.bookedDate === todayStr) {
      const now = new Date();
      now.setMinutes(now.getMinutes() + 2);
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(now.getHours())}:${pad(now.getMinutes())}`;
    }
    return "00:00";
  }, [formData.bookedDate, todayStr]);

  const minStartTime = getMinStartTime();

  const validateTimes = useCallback(() => {
    if (!formData.startTime) { setTimeError("Start time is required"); setIsTimesValidated(false); return false; }
    if (!formData.endTime) { setTimeError("End time is required"); setIsTimesValidated(false); return false; }
    if (!isValid24HourTime(formData.startTime)) { setTimeError("Invalid start time format"); setIsTimesValidated(false); return false; }
    if (!isValid24HourTime(formData.endTime)) { setTimeError("Invalid end time format"); setIsTimesValidated(false); return false; }
    setTimeError("");
    setIsTimesValidated(true);
    return true;
  }, [formData.startTime, formData.endTime]);

  useEffect(() => {
    if (formData.startTime && formData.endTime) validateTimes();
    else if (formData.startTime && !formData.endTime) { setTimeError(""); setIsTimesValidated(false); }
  }, [formData.startTime, formData.endTime, validateTimes]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleStartTimeChange = (time) => {
    setFormData((prev) => ({ ...prev, startTime: time }));
    setIsTimesValidated(false);
    if (formData.endTime && time) {
      const startMinutes = timeToMinutes(time);
      const endMinutes = timeToMinutes(formData.endTime);
      if (endMinutes <= startMinutes) {
        setFormData((prev) => ({ ...prev, endTime: "" }));
        setTimeError("End time must be after start time");
      } else { setTimeError(""); if (time && formData.endTime) validateTimes(); }
    } else if (time && formData.endTime) validateTimes();
  };

  const handleEndTimeChange = (time) => {
    setFormData((prev) => ({ ...prev, endTime: time }));
    if (time && formData.startTime) {
      setTimeError("");
      setIsTimesValidated(true);
    } else if (time && !formData.startTime) { setTimeError("Please set start time first"); setIsTimesValidated(false); }
    else { setTimeError(""); setIsTimesValidated(false); }
  };

  const handleWeightSelect = (selectedOption) => {
    const weight = selectedOption ? selectedOption.value : "";
    setSelectedWeight(weight);
    setFormData((prev) => ({ ...prev, weightCategory: weight, tonnage: weight }));
    setSelectedVehicle(null);
    setFormData((prev) => ({ ...prev, vehicleId: "", vehicleName: "", vehicleType: "", dSNo: "" }));
    if (weight) setFormStep(1);
  };

  const handleVehicleSelection = (vehicle) => {
    if (!isTimesValidated) {
      setTimeError("⚠️ Please set valid start and end times before selecting a vehicle.");
      return;
    }
    const hasDriver = !!(vehicle.dSNo || vehicle.driverSno);
    if (!hasDriver) { alert("⚠️ No driver assigned to this vehicle. Please contact administration."); return; }
    setSelectedVehicle(vehicle);
    setFormData((prev) => ({
      ...prev,
      vehicleId: vehicle.vehicleId || vehicle.id || "",
      vehicleName: vehicle.vehicleId || vehicle.id || "",
      vehicleType: vehicle.vehicleType,
      dSNo: vehicle.driverSno || vehicle.dSNo || "",
      tonnage: vehicle.weightCat || prev.tonnage,
    }));
    setTimeout(() => setFormStep(3), 300);
  };

const handleFromSelect = async (option) => {
  const value = option ? option.value : "";
  
  if (value && value === formData.toLocation) {
    setTimeError("From and To locations cannot be the same.");
    return;
  }
  
  setTimeError(""); 
  const label = option ? option.label : "";
  const name = option?.name || label;
  const raw = option?.raw || null;
  setFormData((prev) => ({ ...prev, fromLocation: value, fromLocationName: name }));
  if (value) {
    const coords = await resolveCoordsForLocation(name || value, raw);
    setFormData((prev) => ({ ...prev, slatitude: coords?.lat || "", slongitude: coords?.lng || "" }));
  }
};

const handleToSelect = async (option) => {
  const value = option ? option.value : "";

  if (value && value === formData.fromLocation) {
    setTimeError("From and To locations cannot be the same.");
    return;
  }

  setTimeError(""); 
  const label = option ? option.label : "";
  const name = option?.name || label;
  const raw = option?.raw || null;
  setFormData((prev) => ({ ...prev, toLocation: value, toLocationName: name }));
  if (value) {
    const coords = await resolveCoordsForLocation(name || value, raw);
    setFormData((prev) => ({ ...prev, elatitude: coords?.lat || "", elongitude: coords?.lng || "" }));
  }
};

  const resetFormData = () => {
    setFormData({
      bookedDate: getLocalDateString(),
      vehicleId: "", vehicleName: "", vehicleType: "", dSNo: "",
      slatitude: "", slongitude: "", elatitude: "", elongitude: "",
      startTime: getNowTimeString(), endTime: "",
      workArea: "", workAreaName: "", workScope: "", notes: "",
      fromLocation: "", fromLocationName: "", toLocation: "", toLocationName: "",
      priority: "M", remark: "", needsResources: false, tonnage: "", weightCategory: "",
    });
    setSelectedWeight("");
    setSelectedVehicle(null);
    setFormStep(0);
    setIsTimesValidated(false);
    setAssignedResources([]);
    setSelectedResourceType("");
  };

  const mapPriority = (value) => {
    if (!value) return "";
    const raw = value.toString().trim();
    const upper = raw.toUpperCase();
    if (["H", "HE", "M", "ML", "L"].includes(upper)) return upper;
    const parenMatch = raw.match(/\(([^)]+)\)/);
    if (parenMatch?.[1]) {
      const code = parenMatch[1].trim().toUpperCase();
      if (["H", "HE", "M", "ML", "L"].includes(code)) return code;
    }
    const lower = raw.toLowerCase();
    if (lower.includes("high") && lower.includes("moderate")) return "HE";
    if (lower.includes("moderate") && lower.includes("low")) return "ML";
    if (lower.includes("high")) return "H";
    if (lower.includes("moderate")) return "M";
    if (lower.includes("low")) return "L";
    return upper.charAt(0);
  };

  const sendBookingAlert = (payload) => {
    if (bookingWS.isReady()) { bookingWS.sendBooking(payload); return; }
    if (authKey) bookingWS.connectAsEmployee(authKey);
    setTimeout(() => { if (bookingWS.isReady()) bookingWS.sendBooking(payload); }, 1500);
  };

  const scheduleBookingAlert = (savedBooking, fallbackBooking) => {
    if (!formData.bookedDate || !formData.startTime) return;
    const scheduledStart = new Date(`${formData.bookedDate}T${formData.startTime}:00`);
    if (isNaN(scheduledStart.getTime())) return;
    const bookingForAlert = {
      bId: savedBooking?.bId || savedBooking?.BId || fallbackBooking?.bId || "",
      vId: savedBooking?.vId || fallbackBooking?.vId || formData.vehicleId,
      dSNo: savedBooking?.dSNo || fallbackBooking?.dSNo || formData.dSNo,
      employeeName: userDetails?.Name || "Employee",
      slatitude: savedBooking?.slatitude || fallbackBooking?.slatitude || "",
      slongitude: savedBooking?.slongitude || fallbackBooking?.slongitude || "",
      elatitude: savedBooking?.elatitude || fallbackBooking?.elatitude || "",
      elongitude: savedBooking?.elongitude || fallbackBooking?.elongitude || "",
      totalDestence: savedBooking?.totalDestence || fallbackBooking?.totalDestence || "0",
      bookingDT: savedBooking?.bookingDT || fallbackBooking?.bookingDT || formatLocalDateTime(new Date()),
      status: savedBooking?.status || fallbackBooking?.status || "P",
      bookingSno: savedBooking?.bookingSno || fallbackBooking?.bookingSno || userDetails?.ServiceNo || "",
      dlatitude: savedBooking?.dlatitude || fallbackBooking?.dlatitude || "",
      dlongitude: savedBooking?.dlongitude || fallbackBooking?.dlongitude || "",
      bsTime: savedBooking?.bsTime || `${formData.bookedDate} ${formData.startTime}:00`,
      beTime: savedBooking?.beTime || `${formData.bookedDate} ${formData.endTime}:00`,
      From: savedBooking?.From || formData.fromLocationName || formData.fromLocation || "",
      TO: savedBooking?.TO || formData.toLocationName || formData.toLocation || "",
      WorkArea: savedBooking?.WorkArea || formData.workAreaName || formData.workArea || "",
      WorkScope: savedBooking?.WorkScope || formData.workScope || "",
      Priority: savedBooking?.Priority || formData.priority || "",
      Remark: savedBooking?.Remark || formData.remark || "",
      BookingStatus: "S",
    };
    const delayMs = scheduledStart.getTime() - Date.now();
    if (delayMs <= 0) { sendBookingAlert(bookingForAlert); return; }
    setTimeout(() => sendBookingAlert(bookingForAlert), delayMs);
  };

  const parseLocalDateTime = (value) => {
    if (!value) return null;
    if (value instanceof Date) return value;
    const raw = String(value).trim();
    if (!raw) return null;
    if (raw.includes("T")) { const d = new Date(raw); return isNaN(d.getTime()) ? null : d; }
    const parts = raw.split(" ");
    if (parts.length >= 2) { const d = new Date(`${parts[0]}T${parts[1]}`); return isNaN(d.getTime()) ? null : d; }
    const d = new Date(raw);
    return isNaN(d.getTime()) ? null : d;
  };

  const scheduleSubBookingAlerts = (subBookings, mainBooking, savedBooking) => {
    if (!Array.isArray(subBookings) || subBookings.length === 0) return;
    subBookings.forEach((sub) => {
      const startTime = parseLocalDateTime(sub.subbsTime);
      if (!startTime) return;
      const bookingForAlert = {
        bId: savedBooking?.bId || savedBooking?.BId || mainBooking?.bId || "",
        vId: sub.subvid || sub.vId || "",
        dSNo: sub.subdSNo || "",
        employeeName: userDetails?.Name || "Employee",
        slatitude: sub.subslatitude || mainBooking?.slatitude || "",
        slongitude: sub.subslongitude || mainBooking?.slongitude || "",
        elatitude: sub.subelatitude || mainBooking?.elatitude || "",
        elongitude: sub.subelongitude || mainBooking?.elongitude || "",
        totalDestence: sub.subtotalDestence || mainBooking?.totalDestence || "0",
        bookingDT: sub.subbookingDT || mainBooking?.bookingDT || formatLocalDateTime(new Date()),
        status: sub.substatus || mainBooking?.status || "P",
        bookingSno: sub.subbookingSno || mainBooking?.bookingSno || userDetails?.ServiceNo || "",
        dlatitude: sub.subdlatitude || mainBooking?.dlatitude || "",
        dlongitude: sub.subdlongitude || mainBooking?.dlongitude || "",
        bsTime: sub.subbsTime || "",
        beTime: sub.subbeTime || "",
        From: sub.subFrom || mainBooking?.From || formData.fromLocationName || formData.fromLocation || "",
        TO: sub.subTO || mainBooking?.TO || formData.toLocationName || formData.toLocation || "",
        WorkArea: mainBooking?.WorkArea || formData.workAreaName || formData.workArea || "",
        WorkScope: mainBooking?.WorkScope || formData.workScope || "",
        Priority: mainBooking?.Priority || formData.priority || "",
        Remark: sub.subRemark || mainBooking?.Remark || formData.remark || "",
        BookingStatus: "S",
      };
      const delayMs = startTime.getTime() - Date.now();
      if (delayMs <= 0) { sendBookingAlert(bookingForAlert); return; }
      setTimeout(() => sendBookingAlert(bookingForAlert), delayMs);
    });
  };

  const createSubBookingsFromResources = () => {
    return assignedResources.map((resource, index) => {
      const vehicleCode = getResourceTypeCode(resource.type);
      return {
        subvid: "",
        subdSNo: "",
        subbsTime: `${formData.bookedDate} ${formData.startTime}:00`,
        subbeTime: `${formData.bookedDate} ${formData.endTime}:00`,
        subFrom: formData.fromLocation,
        subTO: formData.toLocation,
        subRemark: `Resource Type: ${resource.type} - ${resource.remark || ""}`,
        subslatitude: formData.slatitude,
        subslongitude: formData.slongitude,
        subelatitude: formData.elatitude,
        subelongitude: formData.elongitude,
        subtotalDestence: "0",
        substatus: "P",
        subbookingDT: formatLocalDateTime(new Date()),
        subbookingSno: userDetails?.ServiceNo || "",
        subdlatitude: formData.slatitude,
        subdlongitude: formData.slongitude,
        subVehicleCode: vehicleCode,
        resourceType: resource.type,
        resourceId: resource.id,
        resourceName: resource.type,
        startTime: resource.startTime,
        endTime: resource.endTime,
      };
    });
  };

  const handleResourceSubmit = async () => {
    setLoading(true);
    try {
      const now = new Date();
      const subBookings = createSubBookingsFromResources();
      let subBookValue = "";
      if (subBookings.length > 0) {
        const resourceCodes = subBookings.map(sb => sb.subVehicleCode).filter(Boolean);
        subBookValue = resourceCodes.join(",");
      }

      const mainBooking = {
        bId: "",
        vId: formData.vehicleId || "",
        dSNo: formData.dSNo || "",
        slatitude: formData.slatitude,
        slongitude: formData.slongitude,
        elatitude: formData.elatitude,
        elongitude: formData.elongitude,
        status: "P",
        bookingDT: formatLocalDateTime(now),
        bsTime: `${formData.bookedDate} ${formData.startTime}:00`,
        beTime: `${formData.bookedDate} ${formData.endTime}:00`,
        totalDestence: "0",
        dlongitude: formData.slongitude,
        bookingSno: userDetails?.ServiceNo || "",
        dlatitude: formData.slatitude,
        WorkArea: formData.workArea,
        WorkScope: formData.workScope,
        Priority: mapPriority(formData.priority),
        From: formData.fromLocation,
        TO: formData.toLocation,
        Remark: formData.remark,
        SubBook: subBookValue,
        BookingStatus: "S",
        tonnage: formData.tonnage,
      };

      const finalPayload = [mainBooking];
      const apiResponse = await PostBookingRequestDetails(finalPayload);
      const responseData = apiResponse?.data;
      const savedBooking = (Array.isArray(responseData?.resultSet) && responseData.resultSet[0]) || responseData?.result || (Array.isArray(responseData) && responseData[0]) || null;

      if (responseData?.statusCode && responseData.statusCode !== 200) {
        throw new Error(responseData.result || `Backend error: ${responseData.statusCode}`);
      }

      scheduleBookingAlert(savedBooking, mainBooking);
      scheduleSubBookingAlerts(subBookings, mainBooking, savedBooking);

      const newBooking = await create({ ...formData, bId: savedBooking?.bId || savedBooking?.BId || formData.bId, BookingStatus: "S", assignedResources });
      resetFormData();
      setTimeError("");
      if (onBookingCreated) onBookingCreated(newBooking);
    } catch (err) {
      console.error("Booking with resources failed:", err);
      setTimeError(err.message || "Failed to create booking with resources");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    console.log("HANDLE SUBMIT FUNCTION IS ALIVE AND WELL AND EXECUTING!!!")

    e.preventDefault();
    if (!validateTimes() || timeError) return;
    if (!formData.bookedDate) { setTimeError("Booking date is required"); return; }
    if (!formData.startTime || !formData.endTime) { setTimeError("Start and end times are required"); return; }
    if (!formData.fromLocation || !formData.toLocation) { setTimeError("Both from and to locations are required"); return; }
    if (formData.fromLocation === formData.toLocation) { setTimeError("From and To locations cannot be the same."); return; }

    const now = new Date();
    const bookingDT = formatLocalDateTime(now);
    const bsTime = `${formData.bookedDate} ${formData.startTime}:00`;
    const beTime = `${formData.bookedDate} ${formData.endTime}:00`;

    let fromCoords = { lat: formData.slatitude, lng: formData.slongitude };
    let toCoords = { lat: formData.elatitude, lng: formData.elongitude };

    if (!fromCoords.lat || !fromCoords.lng || !toCoords.lat || !toCoords.lng) {
      const [geoFrom, geoTo] = await Promise.all([
        geocodeToLatLng(formData.fromLocationName || formData.workAreaName || formData.fromLocation || formData.workArea),
        geocodeToLatLng(formData.toLocationName || formData.workAreaName || formData.toLocation || formData.workArea),
      ]);
      fromCoords = { lat: fromCoords.lat || geoFrom.lat, lng: fromCoords.lng || geoFrom.lng };
      toCoords = { lat: toCoords.lat || geoTo.lat, lng: toCoords.lng || geoTo.lng };
    }

    if (!fromCoords.lat || !fromCoords.lng || !toCoords.lat || !toCoords.lng) {
      if (!process.env.REACT_APP_ORS_KEY) setTimeError("Pickup/Drop coordinates missing. Add lat/long to Work Areas or set REACT_APP_ORS_KEY.");
      else setTimeError("Pickup/Drop coordinates are missing. Please select locations with valid coordinates.");
      return;
    }

    setFormData((prev) => ({ ...prev, slatitude: fromCoords.lat, slongitude: fromCoords.lng, elatitude: toCoords.lat, elongitude: toCoords.lng }));

    if (formData.needsResources && assignedResources.length > 0) {
      await handleResourceSubmit();
    } else {
      const mainBooking = {
        bId: "", vId: formData.vehicleId || "", dSNo: formData.dSNo || "",
        slatitude: fromCoords.lat, slongitude: fromCoords.lng,
        elatitude: toCoords.lat, elongitude: toCoords.lng,
        status: "P", bookingDT, bsTime, beTime, totalDestence: "0",
        dlongitude: fromCoords.lng, bookingSno: userDetails?.ServiceNo || "",
        dlatitude: fromCoords.lat, WorkArea: formData.workArea, WorkScope: formData.workScope,
        Priority: mapPriority(formData.priority), From: formData.fromLocation, TO: formData.toLocation,
        Remark: formData.remark, SubBook: "", SubBookings: [], BookingStatus: "S", tonnage: formData.tonnage,
      };

      const payload = [mainBooking];

      console.log("SUBMITTING PAYLOAD... : ", payload);

      setLoading(true);
      try {
        const apiResponse = await PostBookingRequestDetails(payload);
        const responseData = apiResponse?.data;

        console.log("REQUEST SUCCEEDED!!!! : ", apiResponse?.data)

        const savedBooking = (Array.isArray(responseData?.resultSet) && responseData.resultSet[0]) || responseData?.result || (Array.isArray(responseData) && responseData[0]) || null;
        scheduleBookingAlert(savedBooking, mainBooking);
        const newBooking = await create({ ...formData, bId: savedBooking?.bId || savedBooking?.BId || formData.bId, BookingStatus: "S" });
        resetFormData();
        setTimeError("");
        if (onBookingCreated) onBookingCreated(newBooking);
      } catch (err) {
        console.error("Booking creation failed:", err);
        setTimeError(err?.message || "Submission failed. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  const selectPortalStyles = { 
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
    control: (base, state) => ({
      ...base,
      minHeight: '38px',
      '@media (max-width: 640px)': {
        minHeight: '42px',
      }
    })
  };

  const StepIndicator = () => (
    <div className="flex items-center justify-between mb-4 sm:mb-6 px-1">
      {[{ step: 0, label: "Weight" }, { step: 1, label: "Dates" }, { step: 2, label: "Details" }].map((item, idx) => (
        <div key={item.step} className="flex items-center flex-1">
          <div className="flex flex-col items-center">
            <div className={`w-7 h-7 sm:w-10 sm:h-10 rounded-full flex items-center justify-center font-bold text-xs sm:text-sm transition-all 
              ${formStep > item.step ? "bg-emerald-500 text-white" : 
                formStep === item.step ? "bg-gray-900 text-white ring-2 sm:ring-4 ring-gray-300" : 
                "bg-gray-200 text-gray-500"}`}>
              {formStep > item.step ? <CheckCircle size={window.innerWidth < 640 ? 14 : 16} /> : item.step + 1}
            </div>
            <span className="text-[8px] sm:text-xs mt-1 font-medium text-gray-600 whitespace-nowrap">{item.label}</span>
          </div>
          {idx < 2 && (
            <div className={`flex-1 h-0.5 mx-1 sm:mx-2 rounded transition-all 
              ${formStep > item.step ? "bg-emerald-500" : "bg-gray-200"}`} />
          )}
        </div>
      ))}
    </div>
  );

  const formatLocalDateTime = (date = new Date()) => {
    const pad = (n) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  };

  const geocodeToLatLng = async (query) => {
    const apiKey = process.env.REACT_APP_ORS_KEY;
    if (!apiKey || !query) return { lat: "", lng: "" };
    try {
      const base = String(query).trim();
      const variants = [base, `${base} Sri Lanka`, `${base}, Sri Lanka`, `${base} LK`].filter(Boolean);
      for (const q of variants) {
        const url = `https://api.openrouteservice.org/geocode/search?api_key=${apiKey}&text=${encodeURIComponent(q)}&boundary.country=LK&size=1`;
        const res = await fetch(url);
        const data = await res.json();
        const feature = data.features?.[0];
        if (!feature) continue;
        const [lng, lat] = feature.geometry.coordinates || [];
        if (typeof lat !== "number" || typeof lng !== "number") continue;
        return { lat: lat.toFixed(6), lng: lng.toFixed(6) };
      }
      return { lat: "", lng: "" };
    } catch (err) { return { lat: "", lng: "" }; }
  };

  const extractCoords = (raw) => {
    if (!raw) return null;
    const pickFirstNumber = (obj, keys) => {
      for (const k of keys) {
        if (obj[k] !== undefined && obj[k] !== null && obj[k] !== "") {
          const n = parseFloat(obj[k]);
          if (!Number.isNaN(n)) return n;
        }
      }
      return null;
    };
    const latKeys = ["latitude", "Latitude", "lat", "LAT", "Lat", "LatitudeValue", "WALatitude", "WA_Latitude", "WA_latitude", "WaLatitude", "WALat", "WorkAreaLatitude"];
    const lngKeys = ["longitude", "Longitude", "lng", "LNG", "Long", "LongitudeValue", "WALongitude", "WA_Longitude", "WA_longitude", "WaLongitude", "WALong", "WorkAreaLongitude"];
    let latNum = pickFirstNumber(raw, latKeys);
    let lngNum = pickFirstNumber(raw, lngKeys);
    if (latNum === null || lngNum === null) {
      const keys = Object.keys(raw || {});
      const latKey = keys.find((k) => k.toLowerCase().includes("lat"));
      const lngKey = keys.find((k) => k.toLowerCase().includes("lon") || k.toLowerCase().includes("lng") || k.toLowerCase().includes("long"));
      if (latNum === null && latKey) { const n = parseFloat(raw[latKey]); if (!Number.isNaN(n)) latNum = n; }
      if (lngNum === null && lngKey) { const n = parseFloat(raw[lngKey]); if (!Number.isNaN(n)) lngNum = n; }
    }
    if (latNum === null || lngNum === null) return null;
    return { lat: latNum.toFixed(6), lng: lngNum.toFixed(6) };
  };

  const resolveCoordsForLocation = async (name, raw) => {
    const fromRaw = extractCoords(raw);
    if (fromRaw) return fromRaw;
    return geocodeToLatLng(name);
  };

  const handleAddResource = (type) => {
    if (assignedResources.length > 0) {
      alert("You can only add ONE resource type per booking. Please remove the existing resource first if you want to change it.");
      return;
    }
    const vehicleCode = getResourceTypeCode(type);
    const newAssignment = {
      id: `${Date.now()}`,
      type: type,
      vehicleCode: vehicleCode,
      startTime: formData.startTime,
      endTime: formData.endTime,
      from: formData.fromLocation,
      fromName: formData.fromLocationName,
      to: formData.toLocation,
      toName: formData.toLocationName,
      remark: formData.remark,
    };
    setAssignedResources((prev) => [...prev, newAssignment]);
    setSelectedResourceType("");
  };

  const handleRemoveResource = (id) => {
    setAssignedResources(assignedResources.filter((r) => r.id !== id));
  };

  const fetchWorkAreasForResources = async () => {
    setLoadingWorkAreas(true);
    setWorkAreaError("");
    try { const data = await getAllWorkAreas(); setWorkAreas(data); } 
    catch (err) { setWorkAreaError("Unable to load work areas"); } 
    finally { setLoadingWorkAreas(false); }
  };

  const getPriorityMeta = (priority) => {
    if (!priority) return { label: "", className: "bg-gray-500" };
    const normalized = priority.toString().trim().toUpperCase();
    if (normalized === "H") return { label: "High", className: "bg-red-500" };
    if (normalized === "HE") return { label: "High to Moderate", className: "bg-orange-500" };
    if (normalized === "M") return { label: "Moderate", className: "bg-yellow-500" };
    if (normalized === "ML") return { label: "Moderate to Low", className: "bg-lime-500" };
    if (normalized === "L") return { label: "Low", className: "bg-green-500" };
    return { label: priority.toString(), className: "bg-gray-500" };
  };

  return (
    <div className="w-full min-h-screen bg-gray-50 py-3 sm:py-6 md:py-8">
      <div className="max-w-2xl mx-auto px-3 sm:px-4">
        {/* Header - Mobile Optimized */}
        <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-3 sm:p-6 mb-4 sm:mb-6">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="p-1.5 sm:p-2 bg-gray-900 rounded-lg">
              <Truck size={window.innerWidth < 640 ? 18 : 20} className="text-white" />
            </div>
            <div>
              <h1 className="text-base sm:text-lg md:text-xl font-semibold text-gray-900">Booking Wizard</h1>
              <p className="text-xs text-gray-500 mt-0.5 sm:mt-1">Complete this form step-by-step to schedule your vehicle</p>
            </div>
          </div>
        </div>

        <StepIndicator />

        <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
          <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-4">
            {/* User Info - Mobile Optimized */}
            {userDetails && (
              <div className="bg-gray-50 border border-gray-100 rounded-lg p-3 flex items-center gap-3">
                <div className="p-1.5 sm:p-2 bg-gray-900 rounded-lg flex-shrink-0">
                  <User size={window.innerWidth < 640 ? 14 : 16} className="text-white" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-gray-900 truncate">{userDetails.Name || "Employee" || "Engineer" || "Supervisor"}</p>
                  <p className="text-xs text-gray-500 truncate">Service No: {userDetails.ServiceNo}</p>
                </div>
              </div>
            )}

            {/* Error Messages - Mobile Optimized */}
            {(error || timeError) && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-3 flex gap-2">
                <AlertCircle size={window.innerWidth < 640 ? 14 : 16} className="text-red-600 flex-shrink-0 mt-0.5" />
                <p className="text-xs text-red-700 break-words">{error || timeError}</p>
              </div>
            )}

            {/* Assigned Resource - Mobile Optimized */}
            {assignedResources.length > 0 && (
              <div className="bg-indigo-50 border border-indigo-100 rounded-lg p-3">
                <h4 className="text-xs font-semibold text-indigo-800 mb-2 flex items-center gap-1">
                  Selected Resource
                </h4>
                {assignedResources.map((resource) => (
                  <div key={resource.id} className="bg-white rounded-lg p-2 flex justify-between items-center gap-2">
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-medium text-gray-800 truncate">{resource.type}</p>
                      <p className="text-xs text-gray-500 truncate">Code: {resource.vehicleCode}</p>
                    </div>
                    <button 
                      type="button" 
                      onClick={() => handleRemoveResource(resource.id)} 
                      className="text-red-500 hover:text-red-700 p-1 flex-shrink-0"
                    >
                      <Trash2 size={window.innerWidth < 640 ? 12 : 14} />
                    </button>
                  </div>
                ))}
              </div>
            )}

            {/* STEP 0: Weight Selection - Mobile Optimized */}
            {formStep === 0 && (
              <div className="space-y-4">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-2">
                    Forklift Weight Category <span className="text-red-500">*</span>
                  </label>
                  <Select 
                    options={weightOptions} 
                    value={weightOptions.find(opt => opt.value === selectedWeight) || null} 
                    onChange={handleWeightSelect} 
                    placeholder="Choose weight category..." 
                    isClearable 
                    className="react-select-container text-sm" 
                    classNamePrefix="react-select" 
                    menuPortalTarget={document.body} 
                    styles={selectPortalStyles} 
                  />
                  {weightCategories.length > 0 && (
                    <div className="mt-3 p-2 bg-gray-50 border border-gray-100 rounded-lg">
                      <p className="text-xs text-gray-600 break-words">
                        Available capacities: {weightCategories.join(", ")}
                      </p>
                    </div>
                  )}
                </div>
                <button 
                  type="button" 
                  onClick={() => selectedWeight && setFormStep(1)} 
                  disabled={!selectedWeight} 
                  className="w-full bg-gray-900 hover:bg-gray-800 disabled:bg-gray-300 text-white font-medium py-2.5 sm:py-2 rounded-lg transition text-sm flex items-center justify-center gap-2"
                >
                  Next: Booking Dates <ChevronRight size={14} />
                </button>
              </div>
            )}

            {/* STEP 1: Date & Location - Mobile Optimized */}
            {formStep === 1 && (
              <div className="space-y-4">
                <div className="bg-emerald-50 border border-emerald-100 rounded-lg p-2">
                  <p className="text-xs font-medium text-emerald-800 break-words">Weight Selected: {selectedWeight}</p>
                </div>
                
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-2">
                    Booking Date <span className="text-red-500">*</span>
                  </label>
                  <input 
                    type="date" 
                    name="bookedDate" 
                    value={formData.bookedDate} 
                    onChange={handleInputChange} 
                    min={getLocalDateString()} 
                    className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:border-gray-400"
                  />
                </div>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <CustomTimePicker 
                    label="Start Time" 
                    value={formData.startTime} 
                    onChange={handleStartTimeChange} 
                    required 
                    min={minStartTime} 
                    error={timeError && timeError.includes("Start") ? timeError : null} 
                  />
                  <CustomTimePicker 
                    label="End Time" 
                    value={formData.endTime} 
                    onChange={handleEndTimeChange} 
                    required 
                    error={timeError && timeError.includes("End") ? timeError : null} 
                  />
                </div>
                
                <div className="space-y-3 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-3">
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-2">
                      From <span className="text-red-500">*</span>
                    </label>
                    <Select
                      options={workAreaOptions1.filter(
                        (o) => o.value !== formData.toLocation
                      )}
                      value={workAreaOptions1.find(o => o.value === formData.fromLocation) || null}
                      onChange={handleFromSelect}
                      placeholder="From location..."
                      isClearable
                      className="react-select-container text-sm"
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      styles={selectPortalStyles}
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-2">
                      To <span className="text-red-500">*</span>
                    </label>
                    <Select
                      options={workAreaOptions1.filter(
                        (o) => o.value !== formData.fromLocation
                      )}
                      value={workAreaOptions1.find(o => o.value === formData.toLocation) || null}
                      onChange={handleToSelect}
                      placeholder="To location..."
                      isClearable
                      className="react-select-container text-sm"
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      styles={selectPortalStyles}
                    />
                  </div>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-3">
                  <button 
                    type="button" 
                    onClick={() => setFormStep(0)} 
                    className="order-2 sm:order-1 flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium py-2.5 sm:py-2 rounded-lg text-sm flex items-center justify-center gap-2"
                  >
                    <ArrowLeft size={14} /> Back
                  </button>
                  <button 
                    type="button" 
                    onClick={() => { if (validateTimes()) setFormStep(3); }} 
                    disabled={!formData.bookedDate || !formData.startTime || !formData.endTime || !formData.fromLocation || !formData.toLocation || timeError !== ""} 
                    className="order-1 sm:order-2 flex-1 bg-gray-900 hover:bg-gray-800 disabled:bg-gray-300 text-white font-medium py-2.5 sm:py-2 rounded-lg text-sm flex items-center justify-center gap-2"
                  >
                    Next <ChevronRight size={14} />
                  </button>
                </div>
              </div>
            )}

            {/* STEP 3: Details & Resources - Mobile Optimized */}
            {formStep === 3 && (
              <div className="space-y-4">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-2">
                    Remarks (Optional)
                  </label>
                  <textarea 
                    name="remark" 
                    value={formData.remark} 
                    onChange={handleInputChange} 
                    placeholder="Add any additional remarks..." 
                    className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:border-gray-400 resize-none" 
                    rows={3}
                  />
                </div>
                
                <div className="bg-gray-50 border border-gray-100 rounded-lg p-3">
                  <label className="flex items-start gap-2 cursor-pointer">
                    <input 
                      type="checkbox" 
                      name="needsResources" 
                      checked={formData.needsResources} 
                      onChange={(e) => { 
                        handleInputChange(e); 
                        if (e.target.checked) fetchWorkAreasForResources(); 
                        else { setAssignedResources([]); setSelectedResourceType(""); } 
                      }} 
                      className="w-4 h-4 mt-0.5 rounded border-gray-300 flex-shrink-0" 
                    />
                    <div>
                      <span className="text-sm font-medium text-gray-700">Need additional resources?</span>
                      <p className="text-xs text-gray-500 mt-0.5">(Trailer, Crane - Only ONE resource can be selected)</p>
                    </div>
                  </label>
                </div>

                {formData.needsResources && (
                  <div className="border border-dashed border-indigo-200 rounded-lg p-4 bg-indigo-50/30 space-y-3">
                    <h3 className="text-sm font-semibold text-gray-800 flex items-center gap-1">Add Resource</h3>
                    <div className="flex flex-wrap gap-2">
                      {RESOURCE_TYPES.map((type) => {
                        const hasResource = assignedResources.length > 0;
                        const isSelected = assignedResources.some(resource => resource.type === type);
                        return (
                          <button 
                            key={type} 
                            type="button" 
                            onClick={() => handleAddResource(type)} 
                            disabled={hasResource && !isSelected} 
                            className={`px-2 sm:px-3 py-1.5 rounded-lg text-xs font-medium transition flex-shrink-0
                              ${hasResource && !isSelected ? "bg-gray-300 cursor-not-allowed opacity-50" : 
                                isSelected ? "bg-emerald-600 text-white" : 
                                "bg-gray-900 text-white hover:bg-gray-800"}`}
                          >
                            {isSelected ? <><CheckCircle size={12} className="inline mr-1" /> {type}</> : <><Plus size={12} className="inline mr-1" /> {type}</>}
                          </button>
                        );
                      })}
                    </div>
                    {assignedResources.length === 0 && (
                      <p className="text-xs text-amber-600">⚠️ Choose one resource type</p>
                    )}
                    {assignedResources.length === 1 && (
                      <p className="text-xs text-emerald-600">✓ Resource selected</p>
                    )}
                    {workAreaError && (
                      <p className="text-xs text-red-600">{workAreaError}</p>
                    )}
                  </div>
                )}

                <div className="flex flex-col sm:flex-row gap-3">
                  <button 
                    type="button" 
                    onClick={() => setFormStep(1)} 
                    className="order-2 sm:order-1 flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium py-2.5 sm:py-2 rounded-lg text-sm flex items-center justify-center gap-2"
                  >
                    <ArrowLeft size={14} /> Back
                  </button>
                  <button 
                    type="submit" 
                    disabled={loading || timeError !== "" || (formData.needsResources && assignedResources.length === 0)} 
                    className="order-1 sm:order-2 flex-1 bg-gray-900 hover:bg-gray-800 disabled:bg-gray-300 text-white font-medium py-2.5 sm:py-2 rounded-lg text-sm flex items-center justify-center gap-2"
                  >
                    {loading ? (
                      <>
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div> 
                        Creating...
                      </>
                    ) : (
                      <>
                        <CheckCircle size={14} /> Confirm Booking
                      </>
                    )}
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default BookingScheduler;